var _path, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgEllipse(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 512,
    height: 97,
    viewBox: "0 0 512 97",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M511 48.5C511 51.4639 509.419 54.4863 506.12 57.5406C502.822 60.5939 497.902 63.5863 491.473 66.4658C478.623 72.2216 459.966 77.4296 436.833 81.8122C390.584 90.5742 326.65 96 256 96C185.35 96 121.416 90.5742 75.1668 81.8122C52.0341 77.4296 33.3768 72.2216 20.5265 66.4658C14.0981 63.5863 9.17818 60.5939 5.88038 57.5406C2.58136 54.4863 1 51.4639 1 48.5C1 45.5361 2.58136 42.5137 5.88038 39.4594C9.17818 36.4061 14.0981 33.4137 20.5265 30.5342C33.3768 24.7784 52.0341 19.5704 75.1668 15.1878C121.416 6.42585 185.35 1 256 1C326.65 1 390.584 6.42585 436.833 15.1878C459.966 19.5704 478.623 24.7784 491.473 30.5342C497.902 33.4137 502.822 36.4061 506.12 39.4594C509.419 42.5137 511 45.5361 511 48.5Z",
    stroke: "url(#paint0_angular_927_4267)",
    strokeWidth: 2
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint0_angular_927_4267",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(256 48.5) rotate(90) scale(48.5 256)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0014837,
    stopColor: "#9F73E6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.249635,
    stopColor: "#9F73E6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.423555,
    stopColor: "#9F73E6",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.58288,
    stopColor: "#9F73E6",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.750354,
    stopColor: "#9F73E6"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgEllipse);
export default __webpack_public_path__ + "static/media/ellipse.4642d415142c3cc3817206a5e26eca83.svg";
export { ForwardRef as ReactComponent };